<!-- 公共组件--查看短信内容 -->
<template>
  <myPopup :flag="isShow" @close="close">
    <div>
      <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
        <div class="sms-center">
          <div class="message-content">
            <!-- 标题 -->
            <div>
              <p style="font-weight: bold;">38节专属活动</p>
            </div>
            <!-- 文本内容 -->
            <div>
              <p>【小小旗舰店】店铺商品全场买一送一，仅限38活动期间，详情点击 #自定义短链#</p>
            </div>
          </div>
          <div>
            <!-- 多媒体内容 -->
            <!-- 图片 -->
            <div class="message-content2">
              <el-image style="max-width: 190px;border-radius: 6px;" :src="img" :z-index="99999"
                :preview-src-list="imgList">
              </el-image>
            </div>
            <!-- 视频 -->
            <div class="message-content2">
              <img src="@/assets/images/视频.png" alt="">
            </div>
            <!-- 音频 -->
            <div class="message-content3">
              <div v-if="!audioShow"><img src="@/assets/images/音频播放键.png" @click="play(true)"></div>
              <div v-else><img src="@/assets/images/音频暂停键.png" @click="play(false)"></div>
              <div><img src="@/assets/images/音频播放条.png"></div>
              <div>0.16</div>
            </div>
          </div>
          <div>
            <div class="message-content">
              拒收请回复R
            </div>
          </div>
        </div>
      </div>
    </div>
  </myPopup>
</template>

<script>
import myPopup from '@/components/myPopupForSms'
export default {
  components: {
    myPopup
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
      img: require('@/assets/images/图片.png'),
      imgList: [require('@/assets/images/图片.png')],
      audioShow: false,
    }
  },
  created() {
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    play(flag){
      this.audioShow = flag
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;

  .sms-center {
    overflow: auto;
    width: 244px;
    height: 355px;
    position: relative;
    top: 73px;
    left: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .message-content {
    word-wrap: break-word;
    padding: 6px 10px;
    border-radius: 10px;
    display: inline-block;
    max-width: 190px;
    min-width: 97px;
    font-size: 12px;
    background-color: #E5E6EA;
    line-height: 18px;
    margin-left: 15px;
    text-align: left;
    margin-top: 2px;
  }

  .message-content2 {
    max-width: 190px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    img {
      max-width: 190px;
      border-radius: 6px;
    }
  }

  .message-content3 {
    background-color: #E5E6EA;
    border-radius: 15px;
    max-width: 136px;
    height: 31px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    >div {
      &:nth-child(1) {
        width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }

      &:nth-child(2) {
        width: 72px;
        display: flex;
        align-items: center;
        padding-left: 4px;

        img {
          width: 28px;
          height: 18px;
        }
      }

      &:nth-child(3) {
        flex: 1;
        color: #ADADAD;
        font-size: 12px;
      }
    }
  }
}
</style>